var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0303 2.96997C22.4278 4.36743 22.4278 6.63317 21.0303 8.03063L9.06198 19.999C8.7851 20.2758 8.44076 20.4757 8.063 20.5787L2.94731 21.9739C2.38744 22.1266 1.87371 21.6128 2.0264 21.053L3.42159 15.9373C3.52462 15.5595 3.72444 15.2152 4.00132 14.9383L15.9697 2.96997C17.3671 1.57251 19.6329 1.57251 21.0303 2.96997ZM15.0002 6.06088L5.06198 15.999C4.96969 16.0913 4.90308 16.206 4.86874 16.332L3.81889 20.1814L7.66833 19.1315C7.79425 19.0972 7.90903 19.0306 8.00132 18.9383L17.9392 8.99988L15.0002 6.06088ZM17.0303 4.03063L16.0602 4.99988L18.9992 7.93988L19.9697 6.96997C20.7813 6.1583 20.7813 4.84231 19.9697 4.03063C19.158 3.21896 17.842 3.21896 17.0303 4.03063Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomInput);
export default __webpack_public_path__ + "static/media/custom_input.919401b89f3d0dca1d929c2d954b422d.svg";
export { ForwardRef as ReactComponent };